import React from "react";
import "./button.css";

const Button = (props) => {
  // console.log("Button", props.onClick);
  return (
    
    <a
      style={{ pointerEvents: props.disabled === true ? "none" : "visible" }}
      className={`hz-linear-button ${props?.className}`}
      onClick={props.onClick}

    >
  
      {props.icon && <img src={props.icon} alt="" />}
      <span>{props.value} </span>
    </a>
  );
};
export default Button;
